import { HTMLAttributes } from 'react';

import { usePagination } from '@hooks/usePagination';

import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@components/pagination/Pagination';

import { cn } from '@utils/tailwind';

export interface BasicPaginationProps extends HTMLAttributes<HTMLDivElement> {
  currentPage: number;
  totalPages: number;
  limitPages: number;
}

export const BasicPagination = ({
  currentPage,
  totalPages,
  limitPages,
  className,
  ...props
}: BasicPaginationProps) => {
  const {
    handlePrevPage,
    handleNextPage,
    handleClickNum,
    numList,
    isDisabledPrev,
    isDisabledNext,
  } = usePagination(currentPage, totalPages, limitPages);

  return (
    <Pagination className={className} {...props}>
      <PaginationContent>
        <PaginationItem
          className={cn(
            'transition-all duration-100',
            isDisabledPrev ? 'hidden' : 'list-item',
          )}
        >
          <PaginationPrevious onClick={() => handlePrevPage()} />
        </PaginationItem>
        {numList.length !== 0 &&
          numList.map((num) => (
            <PaginationItem key={num}>
              <PaginationLink
                // href='#'
                onClick={handleClickNum(num)}
                isActive={currentPage === num}
              >
                {num}
              </PaginationLink>
            </PaginationItem>
          ))}
        <PaginationItem
          className={cn(isDisabledNext ? 'invisible' : 'visible')}
        >
          <PaginationNext onClick={() => handleNextPage()} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};
